export default __webpack_public_path__ + "static/media/Icon_tiny.24f2364e.svg";